import { CRUDApiService } from './CRUDApiService';

export default class NewsFileApiService extends CRUDApiService {
  constructor() {
    super('news-file');
  }
}
